webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(18);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(28);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(21);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _CV = __webpack_require__(20);
	
	var _CV2 = _interopRequireDefault(_CV);
	
	var _Work = __webpack_require__(22);
	
	var _Work2 = _interopRequireDefault(_Work);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		mode: 'history',
		base: __dirname,
		routes: [{ path: '/', component: _Home2.default }, { path: '/cv', component: _CV2.default }, { path: '/work', component: _Work2.default }]
	});
	
	new _vue2.default({
		router: router,
		template: '<App/>',
		components: { App: _App2.default }
	}).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Background = __webpack_require__(19);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _detectBrowser = __webpack_require__(7);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var body = document.body;
	body.classList.add('is-' + _detectBrowser2.default.name);
	
	if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
		body.classList.add('is-ios');
	}
	
	exports.default = {
		name: 'app',
		components: { Background: _Background2.default },
		methods: {
			handleNavClick: function handleNavClick() {
				this.$refs.background.handleNavClick();
			}
		}
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _three = __webpack_require__(17);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _lodash = __webpack_require__(15);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(14);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _noisejs = __webpack_require__(16);
	
	var _d3Ease = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
		name: 'background',
		data: function data() {
			return {
				msg: 'hello vue'
			};
		},
	
		components: {},
	
		created: function created() {
			this.amplitude = 400;
			this.variation = 0.02;
			this.cameraEase = 0.05;
			this.timeToMorph = 8000;
			this.timeToMorphOnClick = 700;
			this.startTime = Date.now();
			this.worldWidth = 40;
			this.worldHeight = 20;
			this.morphing = true;
			this.clickMorphing = false;
	
			this.container = null;
			this.camera = null;
			this.scene = null;
			this.renderer = null;
			this.mouseX = 0;
			this.planeGeo = null;
			this.data = [];
			this.nextData = [];
		},
	
		mounted: function mounted() {
			this.init();
			this.animate();
			window.addEventListener('resize', (0, _lodash4.default)(this.handleResize, 100));
			window.addEventListener('mousemove', (0, _lodash2.default)(this.onMouseMove, 100));
		},
	
		methods: {
			init: function init() {
				this.container = document.createElement('div');
				this.$el.appendChild(this.container);
				this.scene = new THREE.Scene();
	
				this.camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 2000);
				this.camera.position.set(0.0, 400, 400 * 3.5);
	
				var reflectionCube = new THREE.CubeTextureLoader().setPath('static/textures/cube/').load(['blue.jpg', 'blue.jpg', 'blue.jpg', 'blue.jpg', 'blue.jpg', 'blue.jpg']);
				reflectionCube.mapping = THREE.CubeReflectionMapping;
				reflectionCube.format = THREE.RGBFormat;
				this.scene.background = reflectionCube;
	
				this.data = this.generateHeight(this.worldWidth, this.worldHeight);
				this.nextData = this.generateHeight(this.worldWidth, this.worldHeight);
	
				this.planeGeo = new THREE.PlaneGeometry(window.innerWidth * 1.5, 500, this.worldWidth - 1, this.worldHeight - 1);
	
				var vertices = this.planeGeo.vertices;
				for (var i = 0, j = 0, l = vertices.length; i < l; i++, j += 3) {
					vertices[i].z += this.data[i];
				}
	
				var material = new THREE.MeshPhongMaterial({
					color: 0xb2d7ff,
					specular: 0x112233,
					envMap: reflectionCube,
					combine: THREE.MultiplyOperation,
					shading: THREE.SmoothShading,
					reflectivity: 0.9
				});
	
				this.plane = new THREE.Mesh(this.planeGeo, material);
				this.plane.rotation.x = Math.PI / 4;
				this.plane.position.y = window.innerHeight * 0.35;
	
				this.scene.add(this.plane);
	
				var ambient = new THREE.AmbientLight(0x050505);
				this.scene.add(ambient);
				var directionalLight = new THREE.DirectionalLight(0xffffff, 2);
				directionalLight.position.set(2, 1.2, 10).normalize();
				this.scene.add(directionalLight);
	
				this.renderer = new THREE.WebGLRenderer({ antialias: true });
				this.renderer.setPixelRatio(window.devicePixelRatio);
				this.renderer.setSize(window.innerWidth, window.innerHeight);
				this.container.appendChild(this.renderer.domElement);
			},
			generateHeight: function generateHeight(width, height) {
				var noise = new _noisejs.Noise();
				noise.seed(Math.random());
	
				var size = width * height;
				var data = new Uint8Array(size);
	
				var value = 0;
	
	
				for (var x = 0; x < width; x++) {
					data[x] = [];
					for (var y = 0; y < height; y++) {
						value = Math.abs(noise.perlin2(x / width, y / height)) * this.amplitude;
	
	
						data[x * height + y] = value;
					}
				}
				return data;
			},
			animate: function animate() {
				requestAnimationFrame(this.animate);
				this.render();
			},
			render: function render() {
				this.moveCamera();
	
				if (this.clickMorphing) {
					var t = Date.now() - this.startTime;
					if (Date.now() - this.startTime > this.timeToMorphOnClick) {
						this.data = this.nextData;
						this.nextData = this.generateHeight(this.worldWidth, this.worldHeight);
						this.startTimer();
						this.morphing = true;
						this.clickMorphing = false;
					}
	
					t = t / this.timeToMorphOnClick;
					if (t > 1) {
						t = 0;
					}
					var vertices = this.plane.geometry.vertices;
					for (var i = 0; i < vertices.length; i++) {
						vertices[i].z = this.data[i] - (0, _d3Ease.easeCubicInOut)(t) * (this.data[i] - this.nextData[i]);
					}
	
					var y = 1 - t;
					if (y == 1) {
						y = 0;
					}
	
					this.wiggleShape(y);
				} else if (this.morphing) {
					var _t = Date.now() - this.startTime;
					if (Date.now() - this.startTime > this.timeToMorph) {
						this.data = this.nextData;
						this.nextData = this.generateHeight(this.worldWidth, this.worldHeight);
						this.startTimer();
					}
	
					_t = _t / this.timeToMorph;
					if (_t > 1) {
						_t = 0;
					}
					var _vertices = this.plane.geometry.vertices;
					for (var _i = 0; _i < _vertices.length; _i++) {
						_vertices[_i].z = this.data[_i] - (0, _d3Ease.easeCubicInOut)(_t) * (this.data[_i] - this.nextData[_i]);
					}
				}
	
				this.plane.geometry.verticesNeedUpdate = true;
				this.plane.geometry.normalsNeedUpdate = true;
				this.plane.geometry.uvsNeedUpdate = true;
				this.plane.geometry.computeVertexNormals();
	
				this.renderer.render(this.scene, this.camera);
			},
			startTimer: function startTimer() {
				this.startTime = Date.now();
			},
			wiggleShape: function wiggleShape(t) {
				var vertices = this.plane.geometry.vertices;
				var z = 0;
				for (var i = 0; i < vertices.length; i++) {
					z = vertices[i].z + this.amplitude * (this.variation * t) * (Math.random() * 2 - 1);
					if (z < 0) {
						z = 0;
					} else if (z > this.amplitude) {
						z = this.amplitude;
					}
					vertices[i].z = z;
				}
			},
			moveCamera: function moveCamera() {
				this.camera.position.x += (this.mouseX - this.camera.position.x) * this.cameraEase;
	
				this.camera.position.z = 1000;
				this.camera.lookAt(this.scene.position);
			},
			handleResize: function handleResize() {
				this.camera.aspect = window.innerWidth / window.innerHeight;
				this.camera.updateProjectionMatrix();
	
				this.renderer.setSize(window.innerWidth, window.innerHeight);
				this.plane.position.y = window.innerHeight * 0.35;
			},
			onMouseMove: function onMouseMove(event) {
				this.mouseX = (event.clientX - window.innerWidth * 0.5) * 0.5;
			},
			handleNavClick: function handleNavClick() {
				this.morphing = false;
				this.clickMorphing = true;
	
				this.data = [];
				var vertices = this.plane.geometry.vertices;
				for (var i = 0; i < vertices.length; i++) {
					this.data[i] = vertices[i].z;
				}
				this.nextData = this.generateHeight(this.worldWidth, this.worldHeight);
	
				this.startTimer();
			}
		}
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				jobs: [{
					title: 'Web Consultant',
					dates: '2015 - Current',
					company: 'Robot D',
					city: 'Los Angeles, CA',
					description: 'Worked remotely to develop front-end web experiences using modern Javascript frameworks and custom solutions. Built PMHadv.com using Webpack and a custom Javascript framework. Developed, animated and designed APIs for an interactive, online book using ReactJS. Developed a user interface to manipulate 3D models in Unity3D with C# for an iOS application. Animated and developed a graphics-heavy, mobile-first quiz for Blue Cross Blue Shield using custom Javascript, Greensock, and Webpack.'
				}, {
					title: 'Front-End Development Team Lead',
					dates: '2015',
					company: 'Clockwork',
					link: '//clockwork.com/',
					city: 'Minneapolis, MN',
					description: 'Assumed a leadership role as the company transitioned to a team-based structure. Estimated, planned, and oversaw the team&rsquo;s front&ndash;end production. Provided assistance and guidance to team members.'
				}, {
					title: 'Senior Front-End Developer',
					dates: '2012 - 2014',
					company: 'Clockwork',
					link: '//clockwork.com/',
					city: 'Minneapolis, MN',
					description: 'Developed and managed websites on Drupal, SiteCore and an in-house content management system for such clients as General Mills, The <span class="smallcaps">YMCA</span>, and Gold&rsquo;n Plump Chicken. Built a Swift iOS app for trade show displays for JustBARE Chicken. Built an iOS/Android game for Cracker Jack using the Starling Actionscript library.'
				}, {
					title: 'Web Consultant',
					dates: '2010 - 2012',
					company: 'Robot D',
					city: 'Pittsburgh, PA',
					description: 'Developed micro-sites and integrated them into existing web servers for clients that include Reuters and the New York Public Library. Wrote JavaScript and <span class="smallcaps">XML</span> libraries as a communication bridge between dynamic Flash front-end and various <span class="smallcaps">PHP</span> back-end systems.'
				}, {
					title: 'Senior Developer',
					dates: '2009 - 2010',
					company: 'Catch New York',
					city: 'New York, NY',
					description: 'Combined management, programming, and creative skills to grow Catch 24 from 6 employees to 24. Transitioned coding practices and educated employees during expansion and merger.'
				}, {
					title: 'Senior Developer',
					dates: '2004 - 2009',
					company: 'Catch 24 Advertising & Design',
					city: 'New York, NY',
					description: 'Programmed and animated web sites, games, and banners for clients including Lufthansa, DirecTV, CableVision, <span class="smallcaps">IBM</span>, Oracle and The NY Yankees. Developed strong management and presentation skills as key interactive point of contact for Lufthansa Airlines. Lead the team to set platform coding standards and convert from ActionScript 2.0 to 3.0.'
				}, {
					title: 'Developer',
					dates: '2004',
					company: 'The Mixx',
					city: 'New York, NY',
					description: 'Programmed and animated mini-sites for clients such as MSG Entertainment and Scholastic. Translated a strong Object-Oriented programming education into a professional environment. Improved <span class="smallcaps">PHP</span>, MySQL and ActionScript knowledge.'
				}, {
					title: 'Developer / Designer',
					dates: '2001 - 2004',
					company: 'Pittsburgh Tissue Engineering Initiative',
					city: 'Pittsburgh, PA',
					description: 'Animated video and effects for a planetarium show to educate children about tissue engineering. Created online Flash games and web site to accompany the show.'
				}]
			};
		},
	
		components: {}
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            msg: 'hello vue'
	        };
	    },
	
	    components: {}
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				projects: [{
					title: 'PMH Advertising',
					thumbnail: 'pmh.png',
					description: 'I developed the front-end for this agency portfolio site in collaboration with Clockwork. I wrote a custom module-based Javascript framework using Webpack and designed the animations with PMH using Greensock. I worked with clockwork to develop a JSON API to communicate with the Craft CMS.',
					link: '//pmhadv.com'
				}, {
					title: 'Blue Cross Blue Shield Communities',
					thumbnail: 'bcbs.png',
					description: 'For this educational quiz game, I animated and developed a Javascript application using Webpack, Greensock and a custom, object-oriented JS framework. Layouts and animations were built using a mobile-first approach, but the vector-based artwork scales nicely to larger sizes.',
					link: '//pullingtogethermn.com/quiz/'
				}, {
					title: 'Pressure iPad App',
					thumbnail: 'pressure.png',
					description: 'For Pressure, I collaborated with James Cameron’s non-profit organization to develop an interface for manipulating a 3d model of Cameron’s deep sea vessel. I integrated the supplied 3D models and developed the interface and animations in C# with Unity3D. Assisted in integrating the Unity project into a WebView-based iOS app. (Currently unreleased)',
					link: ''
				}, {
					title: 'Breeze Avenue',
					thumbnail: 'breezeave.png',
					description: 'Breeze Ave is an interactive book/art piece, consisting of millions of pages of content that change over time. For this piece, I developed a web interface and menu system using React. Designed the page transitions using purely CSS animation and iterated the user interface to the client’s specifications in an Agile workflow. Collaborated with the PHP developer to write JSON APIs to efficiently pass information from Laravel to React. (Currently unreleased)',
					link: ''
				}, {
					title: 'National Marrow Donor Program Mobile Registration',
					thumbnail: 'nmdp.png',
					description: 'The sign-up process for marrow donation was a dauntingly-long, desktop-only form. At Clockwork, I worked on-site in an Agile environment with NMDP to subdivide registration into multiple steps that are easier to digest. I developed the front-end code and assisted its integration into a legacy .NET platform. I also delivered a static, mobile-first best-practices site for the client’s reference.',
					link: '//bethematch.org/'
				}, {
					title: 'Cracker Jack Mobile Games',
					thumbnail: 'crackerjack.png',
					description: 'An iOS and Android mobile app built with the Starling game engine. At Clockwork, I developed the menu system for the game and assisted in development of several mini-games.',
					link: '//itunes.apple.com/us/app/cracker-jack/id622864095?mt=8'
				}, {
					title: 'Just Bare Chicken',
					thumbnail: 'justbare.png',
					description: 'One of three sites ported to Drupal from a legacy .NET system. I developed the front end for this consumer site, as well as a B2B site. I wrote Drupal themes, assisted with Drupal development and worked with Clockwork’s PHP developers to integrate the themes into the sites',
					link: '//www.justbarechicken.com/'
				}, {
					title: 'NY Public Library Centennial',
					thumbnail: 'nypl.png',
					description: 'For this special occasion, I developed custom Drupal templates and modules and integrated them into established production and development environments. I programmed both the front-end HTML/CSS and the Drupal PHP that integrated into their existing site. I also built a dynamic flash “quilt” which displays user-submitted content as well as content seeded by the library. I used XML to pass information between custom drupal modules and the AS3 code, which leverages a simple MVC design pattern that I built for previous Flash projects.',
					link: ''
				}, {
					title: 'Lufthansa Virtual Pilot I & II',
					thumbnail: 'virtualpilot.png',
					description: 'A geography quiz game that went viral, with over 2 million unique hits in 2010. The celebrity Stephen Fry wrote an unsolicited tweet to his 1.7 million fans that it was a “Brilliant game.” I created the game concept and mechanics, developed the Flash game and a small CodeIgniter site for it to live on. The game was so successful that Lufthansa ordered a sequel that included multiple time-locked trips and Facebook integration.',
					link: '//www.lufthansa-vp.com/'
				}, {
					title: 'Reuters Person Selector',
					thumbnail: 'reuters-persona.png',
					description: 'An internal tool to educate Reuters managers and editors on how to better serve their clients. I was given UX & design documents, art assets and built the project in AS3 using a custom MVC design pattern which leverages the RobotLegs and AS3Signals libraries. The site’s content is extracted from an XML file, a more reasonable solution than a full CMS in this particular case. The tool was then integrated into an existing Jaxer server that is hosted internally at Reuters.. I programmed both the front-end HTML/CSS and the Drupal PHP that integrated into their existing site. I also built a dynamic flash “quilt” which displays user-submitted content as well as content seeded by the library. I used XML to pass information between custom drupal modules and the AS3 code, which leverages a simple MVC design pattern that I built for previous Flash projects.',
					link: '/static/client-work/reuters/persona-selector/persona-selector.html'
				}, {
					title: 'Reuters Virtual Assignment Desk',
					thumbnail: 'reuters-vadesk.png',
					description: 'Another internal tool for Reuters. This game drives home the concept of allocating limited resources to Reuters managers. It was programmed using the same AS3 MVC design pattern as the Persona Selector and integrated onto the same Jaxer server.. I programmed both the front-end HTML/CSS and the Drupal PHP that integrated into their existing site. I also built a dynamic flash “quilt” which displays user-submitted content as well as content seeded by the library. I used XML to pass information between custom drupal modules and the AS3 code, which leverages a simple MVC design pattern that I built for previous Flash projects.',
					link: '/static/client-work/reuters/vadesk/virtual-assignment-desk.html'
				}]
			};
		},
	
		methods: {
			imagePath: function imagePath(image) {
				return '/static/images/' + image;
			}
		},
		components: {}
	};

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(9)
	
	/* script */
	__vue_exports__ = __webpack_require__(1)
	
	/* template */
	var __vue_template__ = __webpack_require__(23)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(11)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(25)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(13)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(27)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d6ab2c22"
	
	module.exports = __vue_exports__


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(12)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(26)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9fe9c90a"
	
	module.exports = __vue_exports__


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(10)
	
	/* script */
	__vue_exports__ = __webpack_require__(5)
	
	/* template */
	var __vue_template__ = __webpack_require__(24)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-61ccf6a6"
	
	module.exports = __vue_exports__


/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('Background', {
	    ref: "background"
	  }), " ", _h('span', {
	    staticClass: "site-title"
	  }, ["ROBOT D"]), " ", _h('nav', {
	    staticClass: "nav"
	  }, [_h('ul', {
	    staticClass: "nav-list"
	  }, [_h('li', {
	    staticClass: "nav-li"
	  }, [_h('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/",
	      "exact": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.handleNavClick($event)
	      }
	    }
	  }, ["About"])]), " ", _h('li', {
	    staticClass: "nav-li"
	  }, [_h('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/cv"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.handleNavClick($event)
	      }
	    }
	  }, ["CV"])]), " ", _h('li', {
	    staticClass: "nav-li"
	  }, [_h('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/work"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.handleNavClick($event)
	      }
	    }
	  }, ["Work"])])])]), " ", _h('div', {
	    staticClass: "content"
	  }, [_h('router-view')])])
	},staticRenderFns: []}

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('transition', {
	    attrs: {
	      "name": "slide-fade"
	    }
	  }, [_h('div', {
	    staticClass: "page work"
	  }, [_h('ul', {
	    staticClass: "project-list"
	  }, [_vm._l((_vm.projects), function(project) {
	    return _h('li', {
	      staticClass: "project"
	    }, [(project.thumbnail && project.thumbnail != '') ? _h('img', {
	      staticClass: "project__thumbnail",
	      attrs: {
	        "src": _vm.imagePath(project.thumbnail)
	      }
	    }) : _vm._e(), " ", _h('h2', {
	      staticClass: "project__title"
	    }, [_vm._s(project.title)]), " ", _h('p', {
	      staticClass: "project__description"
	    }, [_vm._s(project.description)]), " ", (project.link && project.link != '') ? _h('a', {
	      staticClass: "project__link",
	      attrs: {
	        "href": project.link
	      }
	    }, ["View\n\t\t\t\t\tthe site"]) : _vm._e()])
	  })])])])
	},staticRenderFns: []}

/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "bg"
	  })
	},staticRenderFns: []}

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('transition', {
	    attrs: {
	      "name": "slide-fade"
	    }
	  }, [_h('div', {
	    staticClass: "page home"
	  }, [_h('p', ["Robot D is Adam Drobotij, a web developer with 15 years of experience interpreting great designs and\n\t\t\tmaking them shine on the interactive page. He is skilled with many modern web programming\n\t\t\tlanguages (Javascript, ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["HTML5"]), ", ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["CSS3"]), " and a\n\t\t\tfew ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["CSS"]), "-processors like ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["SASS"]), " and\n\t\t\tPost-", _h('span', {
	    staticClass: "smallcaps"
	  }, ["CSS"]), ",\n\t\t\t", _h('span', {
	    staticClass: "smallcaps"
	  }, ["LAMP"]), ", various front-end frameworks like\n\t\t\t", _h('a', {
	    attrs: {
	      "href": "https://facebook.github.io/react/"
	    }
	  }, ["React"]), ",\n\t\t\t", _h('a', {
	    attrs: {
	      "href": "http://angularjs.org/"
	    }
	  }, ["Angular"]), " and ", _h('a', {
	    attrs: {
	      "href": "https://jquery.com/"
	    }
	  }, ["JQuery"]), ") but Adam’s\n\t\t\texpertise lies in applying his art and animation education to the site-building process; resulting in a\n\t\t\tslick, intuitive experience for the user.\n\t\t\tLearning new skills is always interesting to him. He built this site to learn\n\t\t\t", _h('a', {
	    attrs: {
	      "href": "https://vuejs.org/"
	    }
	  }, ["VueJS"]), " and refresh his memory\n\t\t\tof ", _h('a', {
	    attrs: {
	      "href": "https://threejs.org"
	    }
	  }, ["ThreeJS"]), ".\n\t\t\tLately, he’s been playing with Graphics Shaders and ", _h('a', {
	    attrs: {
	      "href": "https://unity3d.com/"
	    }
	  }, ["Unity3D"]), "."]), " ", _h('p', ["Adam would love to work with you. Connect with him on ", _h('a', {
	    attrs: {
	      "href": "http://www.linkedin.com/in/adamdrobotij"
	    }
	  }, ["LinkedIn"]), "."]), " ", _h('p', ["Also, if you would just like to talk about video games, football or food… he’s down for that."])])])
	},staticRenderFns: []}

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('transition', {
	    attrs: {
	      "name": "slide-fade"
	    }
	  }, [_h('div', {
	    staticClass: "page cv"
	  }, [_h('h1', {
	    staticClass: "cv-title"
	  }, ["Adam Drobotij"]), " ", _h('h2', {
	    staticClass: "cv-email"
	  }, [_h('a', {
	    attrs: {
	      "href": "mailto:hireme@robot-d.com"
	    }
	  }, ["hireme@robot-d.com"])]), " ", _h('a', {
	    staticClass: "cv-pdf",
	    attrs: {
	      "href": "/static/drobotij_resume_2017.pdf"
	    }
	  }, ["pdf"]), " ", _h('hr'), " ", _h('ul', {
	    staticClass: "cv-list job-list"
	  }, [_vm._l((_vm.jobs), function(job) {
	    return _h('li', {
	      staticClass: "cv-li job"
	    }, [_h('div', {
	      staticClass: "col__left"
	    }, [_h('h2', {
	      staticClass: "job__title"
	    }, [_vm._s(job.title)]), " ", _h('div', {
	      staticClass: "job__dates"
	    }, [_vm._s(job.dates)])]), " ", _h('div', {
	      staticClass: "col__right"
	    }, [(job.link) ? _h('div', [_h('h3', {
	      staticClass: "job__company"
	    }, [_h('a', {
	      attrs: {
	        "href": job.link
	      }
	    }, [_vm._s(job.company)]), (job.city) ? _h('span', [" – ", _h('span', {
	      staticClass: "job__city"
	    }, [_vm._s(job.city)])]) : _vm._e()])]) : _h('div', [_h('h3', {
	      staticClass: "job__company"
	    }, [_vm._s(job.company)])]), " ", " ", _h('p', {
	      staticClass: "job__description",
	      domProps: {
	        "innerHTML": _vm._s(job.description)
	      }
	    }, [_vm._s(job.description)])])])
	  })]), " ", _h('hr'), " ", _h('ul', {
	    staticClass: "cv-list education-list"
	  }, [_h('li', {
	    staticClass: "cv-li"
	  }, [_h('h2', {
	    staticClass: "col__left cv__subhead"
	  }, ["Education"]), " ", _h('div', {
	    staticClass: "col__right"
	  }, [_h('h3', {
	    staticClass: "education__title"
	  }, ["Carnegie Mellon University – ", _h('span', {}, ["Pittsburgh, PA"])]), " ", _h('p', {
	    staticClass: "education__description"
	  }, [_h('span', {
	    staticClass: "smallcaps"
	  }, ["BFA"]), " in Multimedia Art, with a secondary focus on Computer Science."])])])]), " ", _h('hr'), " ", _h('ul', {
	    staticClass: "cv-list skills-list"
	  }, [_h('li', {
	    staticClass: "cv-li"
	  }, [_h('div', {
	    staticClass: "col__left"
	  }, [_h('h2', {
	    staticClass: "cv__subhead"
	  }, ["Strengths"])]), " ", _h('div', {
	    staticClass: "col__right"
	  }, [_h('p', [_h('span', {
	    staticClass: "smallcaps"
	  }, ["HTML"]), ", ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["CSS/SASS/LESS"]), ", JavaScript, ReactJS, AngularJS, ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["PHP"]), ", MySQL, Swift iOS, Unity3D, C#, Javascript-based Animation, Drupal, WordPress, ExpressionEngine, jQuery, Bootstrap, SiteCore, ", _h('span', {
	    staticClass: "smallcaps"
	  }, ["SVN"]), " & Git,\n\t\t\t\t\tActionScript3, Flash Animation, Adobe Suite"])])]), " ", _h('li', {
	    staticClass: "cv-li"
	  }, [_h('div', {
	    staticClass: "col__left"
	  }, [_h('h2', {
	    staticClass: "cv__subhead"
	  }, ["Weaknesses"])]), " ", _h('div', {
	    staticClass: "col__right"
	  }, [_h('p', ["Homemade Pasta, Bourbon-based Cocktails, Overwatch, Experimental Video Games"])])])])])])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.393798e09520d274d21e.js